import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as ruleActions from '../store/actions';
import { ModuleConfiguration } from '../business-rule.module.config';
import { LoadPagePayload } from '../../pillar/common/actions/LoadPagePayload';
import { ParameterService } from './ParameterService';
import { ModelResponse } from '../../core/services/ModelResponse';
import { UpdateParametersModel } from "../models/UpdateParametersModel";
import { ParameterModel } from "../models/ParameterModel";
import * as actions from '../store/actions';
import * as workspaceActions from '../../pillar/workspace/store/actions';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseMessage } from '../../core/services/ResponseMessage';
import { ResponseMessageType } from '../../core/services/ResponseMessageType';


@Injectable()
export class ParameterServiceEffects {
  constructor(
    private parameterService: ParameterService,
    private actions$: Actions
  ) {
  }

  @Effect()
  getParameters$: Observable<Action> = this.actions$.ofType(actions.GET_PARAMETERS)
      .map((a: actions.GetParametersAction ) => a.payload)
      .switchMap((payload: LoadPagePayload) => this.parameterService.getParameters(payload.page, payload.pageSize, payload.sort, payload.sortDirection, payload.searchTerm)
        .map((response: ModelResponse<UpdateParametersModel>) => {
        
          return new actions.GetParametersSuccessAction({ updateParameterModel: response.model});
      }));

  @Effect()
  removeParameter$: Observable<Action> = this.actions$.ofType(workspaceActions.removeModelType<UpdateParametersModel, ParameterModel>(ModuleConfiguration.moduleName, UpdateParametersModel, ParameterModel))
      .switchMap((a: workspaceActions.RemoveModelAction<UpdateParametersModel, ParameterModel>) =>
        this.parameterService.removeParameter(a.payload.model.key)
      .catch((error: HttpErrorResponse) => {
        var response = new ModelResponse<ParameterModel>();
        response.hasError = true;
        var responseMessage = new ResponseMessage();
        responseMessage.type = ResponseMessageType.Error;
        responseMessage.value = error.message;
        response.messages = [responseMessage];
        return Observable.of(response);
      })
          .map((response: ModelResponse<ParameterModel>) => {
        if (response.hasError) {
          return new workspaceActions.UpdateModelErrorAction(
            {
              action: a,
              errors: response.messages.filter(m => m.type === ResponseMessageType.Error).map(m => m.value)
            });
        }
        return new workspaceActions.RemoveModelSuccessAction(ModuleConfiguration.moduleName,
          UpdateParametersModel,
          ParameterModel,
          {
            key: a.payload.key,
            model: response.model,
            control: a.payload.control
          });
        }));

  @Effect()
  addParameter$: Observable<Action> = this.actions$.ofType(workspaceActions.updateModelType<UpdateParametersModel, ParameterModel>(ModuleConfiguration.moduleName, UpdateParametersModel, ParameterModel))
      .filter((a: workspaceActions.UpdateModelAction<UpdateParametersModel, ParameterModel>) => a.payload.model.key === undefined || a.payload.model.key === '')
      .switchMap((a: workspaceActions.UpdateModelAction<UpdateParametersModel, ParameterModel>) => this.parameterService.addParameter(a.payload.key, a.payload.model)
      .catch((error: HttpErrorResponse) => {
        var response = new ModelResponse<ParameterModel>();
        response.hasError = true;
        var responseMessage = new ResponseMessage();
        responseMessage.type = ResponseMessageType.Error;
        responseMessage.value = error.message;
        response.messages = [responseMessage];
        return Observable.of(response);
      })
        .map((response: ModelResponse<ParameterModel>) => {
        if (response.hasError) {
          return new workspaceActions.UpdateModelErrorAction(
            {
              action: a,
              errors: response.messages.filter(m => m.type === ResponseMessageType.Error).map(m => m.value)
            });
        }
        return new workspaceActions.UpdateModelSuccessAction(ModuleConfiguration.moduleName,
          UpdateParametersModel,
          ParameterModel,
          {
            key: a.payload.key,
            model: response.model,
            control: a.payload.control
          });
      }));
}



// WEBPACK FOOTER //
// ./src/app/businessRule/services/ParameterService.effects.ts